import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import hebrew from "./locales/he.json";
import english from "./locales/en.json";
import french from "./locales/fr.json";
import portuguese from "./locales/pt.json";
import spanish from "./locales/esp.json";

i18n.use(initReactI18next).init({
  fallbackLng: "en",
  lng: "en",
  resources: {
    en: {
      translations: english,
    },
    he: {
      translations: hebrew,
    },
    fr: {
      translations: french,
    },
    pt: {
      translations: portuguese,
    },
    esp: {
      translations: spanish,
    },
  },
  ns: ["translations"],
  defaultNS: "translations",
});

i18n.languages = ["en", "he", "fr", "pt", "esp"];

export default i18n;
